
<template>
  <div>
    <Header />
    <TitlePage />
    <div class="faq">
      <b-container fluid="md">
        <b-tabs class="tabs-list" v-model="tabIndex" v-if="!isTablet">
          <b-tab
            :active="
              $route.hash === '#frequently-asked-questions' ||
              $route.hash === ''
            "
            @click="activeTab('frequentlyAskedQuestions')"
          >
            <template v-slot:title>{{ $t("faq.faq") }}</template>
            <div class="tab-list">
              <div class="right-side">
                <h5>{{ $t("faq.accounts.name") }}</h5>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-1>
                    <span>Q. {{ $t("faq.accounts.question.1") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-1"
                    :visible="$route.hash.match('-1') ? false : true"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body
                      >A. {{ $t("faq.accounts.answer.1") }}</b-card-body
                    >
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-2>
                    <span>Q. {{ $t("faq.accounts.question.2") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-2"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-2') ? false : true"
                  >
                    <b-card-body>
                      <br />
                      <br />A. {{ $t("faq.accounts.answer.2") }}
                      <br />
                      <ol>
                        <li>
                          {{ $t("faq.accounts.answer.2a") }}
                          <b>{{ $t("faq.accounts.answer.2b") }}</b>
                          {{ $t("faq.accounts.answer.2c") }}
                        </li>
                        <li>{{ $t("faq.accounts.answer.2d") }}</li>
                        <li>{{ $t("faq.accounts.answer.2e") }}</li>
                      </ol>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-3>
                    <span>Q. {{ $t("faq.accounts.question.3") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-3"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-3') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.accounts.answer.3") }}
                      <b>{{ $t("faq.accounts.answer.3a") }}</b>
                      {{ $t("faq.accounts.answer.3b") }}
                      <b>{{ $t("faq.accounts.answer.3c") }}</b>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <h5>{{ $t("faq.searching.name") }}</h5>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-4>
                    <span>Q. {{ $t("faq.searching.question.1") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-4"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-4') ? false : true"
                  >
                    <b-card-body>
                      <br />A.
                      {{ $t("faq.searching.answer.1") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-5>
                    <span>Q. {{ $t("faq.searching.question.2") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-5"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-5') ? false : true"
                  >
                    <b-card-body>
                      <br />A. <b>{{ $t("faq.searching.answer.2") }}</b>
                      {{ $t("faq.searching.answer.2a") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-6>
                    <span>Q. {{ $t("faq.searching.question.3") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-6"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-6') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.searching.answer.3") }}
                      <b>{{ $t("faq.searching.answer.3a") }}</b>
                      {{ $t("faq.searching.answer.3b") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-7>
                    <span>Q. {{ $t("faq.searching.question.4") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-7"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-7') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.searching.answer.4") }}
                      <b>{{ $t("faq.searching.answer.4a") }}</b>
                      {{ $t("faq.searching.answer.4b") }}
                      <b>{{ $t("faq.searching.answer.4c") }}</b>
                      {{ $t("faq.searching.answer.4d") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-8>
                    <span>Q. {{ $t("faq.searching.question.5") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-8"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-8') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.searching.answer.5") }}
                      <b>{{ $t("faq.searching.answer.5a") }}</b>
                      {{ $t("faq.searching.answer.5b") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <h5>{{ $t("faq.posting.name") }}</h5>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-9>
                    <span>Q. {{ $t("faq.posting.question.1") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-9"
                    :visible="$route.hash.match('-9') ? true : false"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.posting.answer.1") }}
                      <br />
                      <ol>
                        <li>
                          {{ $t("faq.posting.answer.1a") }}
                          <b>{{ $t("faq.posting.answer.1b") }}</b>
                          {{ $t("faq.posting.answer.1c") }}
                        </li>
                        <li>
                          {{ $t("faq.posting.answer.1d") }}
                          <b>{{ $t("faq.posting.answer.1e") }}</b>
                          {{ $t("faq.posting.answer.1f") }}
                        </li>
                        <li>
                          {{ $t("faq.posting.answer.1g") }}
                          <b>{{ $t("faq.posting.answer.1h") }}</b>
                        </li>
                        <li>
                          {{ $t("faq.posting.answer.1i") }}
                          <b>{{ $t("faq.posting.answer.1j") }}</b>
                        </li>
                        <li>
                          {{ $t("faq.posting.answer.1k") }}
                          <b>{{ $t("faq.posting.answer.1l") }}</b>
                          {{ $t("faq.posting.answer.1m") }}
                          <b>{{ $t("faq.posting.answer.1n") }}</b>
                          {{ $t("faq.posting.answer.1o") }}
                        </li>
                        <li>
                          {{ $t("faq.posting.answer.1p") }}
                          <b>{{ $t("faq.posting.answer.1q") }}</b>
                          {{ $t("faq.posting.answer.1r") }}
                        </li>
                        <li>
                          <b>{{ $t("faq.posting.answer.1s") }}</b>
                          {{ $t("faq.posting.answer.1t") }}
                        </li>
                        <li>
                          {{ $t("faq.posting.answer.1u") }}
                          <b>{{ $t("faq.posting.answer.1v") }}</b>
                        </li>
                        <li>
                          {{ $t("faq.posting.answer.1w") }}
                          <b>{{ $t("faq.posting.answer.1x") }}</b>
                          {{ $t("faq.posting.answer.1y") }}
                        </li>
                        <li>
                          {{ $t("faq.posting.answer.1z") }}
                          <b>{{ $t("faq.posting.answer.1aa") }}</b>
                        </li>
                        <li>
                          {{ $t("faq.posting.answer.1ab") }}
                          <b>{{ $t("faq.posting.answer.1ac") }}</b>
                          {{ $t("faq.posting.answer.1ad") }}
                        </li>
                      </ol>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1" id="toggle-10">
                  <b-button v-b-toggle.accordion-10>
                    <span>Q. {{ $t("faq.posting.question.2") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-10"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-10') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.posting.answer.2") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1" id="toggle-11">
                  <b-button v-b-toggle.accordion-11>
                    <span>Q. {{ $t("faq.posting.question.3") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-11"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-11') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.posting.answer.3") }} <br />•
                      {{ $t("faq.posting.answer.3a") }} <br />•
                      {{ $t("faq.posting.answer.3b") }} <br />•
                      {{ $t("faq.posting.answer.3c") }} <br />•
                      {{ $t("faq.posting.answer.3d") }} <br />•
                      {{ $t("faq.posting.answer.3e") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1" id="toggle-12">
                  <b-button v-b-toggle.accordion-12>
                    <span>Q. {{ $t("faq.posting.question.4") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-12"
                    :visible="faq || $route.hash.match('-12')"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.posting.answer.4") }}
                      <router-link
                        id="seukhaiPromoteYourAd"
                        style="color: #444444"
                        :to="$i18nRoute({ name: 'ads' })"
                        >http://marketplace.khaosod.co.th/ads/promote-your-ad/</router-link
                      >
                      {{ $t("faq.posting.answer.4a") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-13>
                    <span>Q. {{ $t("faq.posting.question.5") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-12"
                    :visible="faq || $route.hash.match('-12')"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.posting.answer.4") }}
                      <router-link
                        id="seukhaiPromoteYourAd"
                        style="color: #444444"
                        :to="$i18nRoute({ name: 'ads' })"
                        >http://classifieds.thairath.co.th/ads/promote-your-ad/</router-link
                      >
                      {{ $t("faq.posting.answer.4a") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-13>
                    <span>Q. {{ $t("faq.posting.question.5") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-13"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-13') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.posting.answer.5") }}
                      <br />
                      <b>{{ $t("faq.posting.answer.5a") }}</b>
                      {{ $t("faq.posting.answer.5b") }}
                      <br />
                      <b>{{ $t("faq.posting.answer.5c") }}</b>
                      {{ $t("faq.posting.answer.5d") }}
                      <br />
                      <b>{{ $t("faq.posting.answer.5e") }}</b>
                      {{ $t("faq.posting.answer.5f") }}
                      <br />
                      <b>{{ $t("faq.posting.answer.5g") }}</b>
                      {{ $t("faq.posting.answer.5h") }}
                      <br />
                      <b>{{ $t("faq.posting.answer.5i") }}</b>
                      {{ $t("faq.posting.answer.5j") }}
                      <br />
                      <b>{{ $t("faq.posting.answer.5k") }}</b>
                      {{ $t("faq.posting.answer.5l") }}
                      <br />
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-14>
                    <span>Q. {{ $t("faq.posting.question.6") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-14"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-14') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.posting.answer.6") }}
                      <b>{{ $t("faq.posting.answer.6a") }}</b>
                      {{ $t("faq.posting.answer.6b") }}
                      <b>{{ $t("faq.posting.answer.6c") }}</b>
                      {{ $t("faq.posting.answer.6d") }}
                      <b>{{ $t("faq.posting.answer.6e") }}</b>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-15>
                    <span>Q. {{ $t("faq.posting.question.7") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-15"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-15') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.posting.answer.7") }}
                      <b>{{ $t("faq.posting.answer.7a") }}</b>
                      {{ $t("faq.posting.answer.7b") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-16>
                    <span>Q. {{ $t("faq.posting.question.8") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-16"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-16') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.posting.answer.8") }}
                      <b>{{ $t("faq.posting.answer.8a") }}</b>
                      {{ $t("faq.posting.answer.8b") }}
                      <b>{{ $t("faq.posting.answer.8c") }}</b>
                      {{ $t("faq.posting.answer.8d") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-17>
                    <span>Q. {{ $t("faq.posting.question.9") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-17"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-17') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.posting.answer.9") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-18>
                    <span>Q. {{ $t("faq.posting.question.10") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-18"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-18') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.posting.answer.10") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-19>
                    <span>Q. {{ $t("faq.posting.question.11") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-19"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-19') ? false : true"
                  >
                    <b-card-body
                      ><br />A. {{ $t("faq.posting.answer.11") }}</b-card-body
                    >
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-20>
                    <span>Q. {{ $t("faq.posting.question.12") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-20"
                    :visible="$route.hash.match('-20') ? true : false"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.posting.answer.12") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-21>
                    <span>Q. {{ $t("faq.posting.question.13") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-21"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-21') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.posting.answer.13") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-22>
                    <span>Q. {{ $t("faq.posting.question.14") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-22"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-22') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.posting.answer.14") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-23>
                    <span>Q. {{ $t("faq.posting.question.15") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-23"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-23') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.posting.answer.15") }}
                      <b>{{ $t("faq.posting.answer.15a") }}</b>
                      {{ $t("faq.posting.answer.15b") }}
                      <b>{{ $t("faq.posting.answer.15c") }}</b>
                      {{ $t("faq.posting.answer.15d") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-24>
                    <span>Q. {{ $t("faq.posting.question.16") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-24"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-24') ? false : true"
                  >
                    <b-card-body
                      >A. {{ $t("faq.posting.answer.16") }}</b-card-body
                    >
                  </b-collapse>
                </b-card>
                <h5>{{ $t("faq.other.name") }}</h5>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-25>
                    <span>Q. {{ $t("faq.other.question.1") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-25"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-25') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.other.answer.1") }}
                      <b>{{ $t("faq.other.answer.1a") }}</b
                      >{{ $t("faq.other.answer.1b") }}
                      <b>{{ $t("faq.other.answer.1c") }}</b>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                  <b-button v-b-toggle.accordion-26>
                    <span>Q. {{ $t("faq.other.question.2") }}</span>
                    <span class="when-opened">
                      <ChevronUpIcon />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon />
                    </span>
                  </b-button>

                  <b-collapse
                    id="accordion-26"
                    accordion="my-accordion"
                    role="tabpanel"
                    :visible="$route.hash.match('-26') ? false : true"
                  >
                    <b-card-body>
                      <br />A. {{ $t("faq.other.answer.2") }}
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </b-tab>
          <b-tab
            :active="$route.hash === '#terms-of-use'"
            @click="activeTab('termsOfUse')"
          >
            <template v-slot:title>{{ $t("faq.termscondition") }}</template>

            <div class="tab-list pdf-tab">
              <div class="column-div">
                <div class="left-side">
                  <a
                    @click="
                      changePrivacyPolicy(
                        false,
                        'TS',
                        'Terms_of_Service_Khaosod_FINAL'
                      )
                    "
                    v-bind:class="{ activeLang: !langTypeTS }"
                    >{{ $t("faq.thai") }} <span v-if="!langTypeTS">></span></a
                  >
                  <a
                    @click="changePrivacyPolicy(true, 'TS', 'Terms of Service')"
                    v-bind:class="{ activeLang: langTypeTS }"
                    >{{ $t("faq.english") }} <span v-if="langTypeTS">></span></a
                  >
                </div>
                <div class="right-side">
                  <pdf
                    v-for="i in numPagesTS"
                    :key="i"
                    :page="i"
                    :src="srcTS"
                    style="display: inline-block; width: 100%"
                  ></pdf>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab
            :active="$route.hash === '#privacy-policy'"
            @click="activeTab('privacyPolicy')"
          >
            <template v-slot:title>{{ $t("faq.privacypolicy") }}</template>

            <div class="tab-list pdf-tab">
              <div class="column-div">
                <div class="left-side">
                  <a
                    @click="
                      changePrivacyPolicy(
                        false,
                        'PP',
                        'Privacy_Policy_Khaosod_FINAL'
                      )
                    "
                    v-bind:class="{ activeLang: !langTypePP }"
                    >{{ $t("faq.thai") }} <span v-if="!langTypePP">></span></a
                  >
                  <a
                    @click="changePrivacyPolicy(true, 'PP', 'Privacy Policy')"
                    v-bind:class="{ activeLang: langTypePP }"
                    >{{ $t("faq.english") }} <span v-if="langTypePP">></span></a
                  >
                </div>
                <div class="right-side">
                  <pdf
                    v-for="i in numPagesPP"
                    :key="i"
                    :page="i"
                    :src="srcPP"
                    style="display: inline-block; width: 100%"
                  ></pdf>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab
            :active="$route.hash === '#listing-policy'"
            @click="activeTab('listingPolicy')"
          >
            <template v-slot:title>{{
              $t("faq.anncouncemnetpolicy")
            }}</template>
            <div class="tab-list pdf-tab">
              <div class="column-div">
                <div class="left-side">
                  <a
                    @click="
                      changePrivacyPolicy(
                        false,
                        'LP',
                        'Listing_Policy_Khaosod_FINAL'
                      )
                    "
                    v-bind:class="{ activeLang: !langTypeLP }"
                    >{{ $t("faq.thai") }} <span v-if="!langTypeLP">></span></a
                  >
                  <a
                    @click="changePrivacyPolicy(true, 'LP', 'Listing Policy')"
                    v-bind:class="{ activeLang: langTypeLP }"
                    >{{ $t("faq.english") }} <span v-if="langTypeLP">></span></a
                  >
                </div>
                <div class="right-side">
                  <pdf
                    v-for="i in numPagesLP"
                    :key="i"
                    :page="i"
                    :src="srcLP"
                    style="display: inline-block; width: 100%"
                  ></pdf>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab
            :active="$route.hash === '#do-not-sell'"
            @click="activeTab('doNotSell')"
          >
            <template v-slot:title>{{ $t("Personal Information") }}</template>
            <div class="tab-list pdf-tab">
              <div class="column-div">
                <!-- <div class="left-side">
                  <a @click="changePrivacyPolicy(false, 'LP', 'Listing_Policy_TH')" v-bind:class="{'activeLang': !langTypeLP}">{{ $t('faq.thai') }} <span v-if="!langTypeLP">></span></a>
                  <a @click="changePrivacyPolicy(true, 'LP', 'Listing Policy')" v-bind:class="{'activeLang': langTypeLP}" >{{ $t('faq.english') }} <span v-if="langTypeLP">></span></a>
                </div> -->
                <div class="right-side">
                  <pdf
                    v-for="i in numPagesDN"
                    :key="i"
                    :page="i"
                    :src="srcDN"
                    style="display: inline-block; width: 100%"
                  ></pdf>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab
            :active="$route.hash === '#contact-us'"
            @click="activeTab('contactUs')"
          >
            <template v-slot:title>{{ $t("faq.contactUs") }}</template>
            <div class="tab-list">
              <div class="left-side-contact">
                <a
                  href="/th/ads"
                  class="advertise-withus-button-class"
                  id="advertise-withus-button"
                >
                  <img
                    src="../../assets/logo_1.png"
                    style="width: 320px; margin-bottom: 30px"
                    :alt="
                      $t('altTag', {
                        affiliate: $root.affiliate,
                      })
                    "
                  />
                  <h5 style="text-align: center">
                    {{
                      $t("faq.Advertise with us", {
                        home_title: $root.siteTitle,
                      })
                    }}
                  </h5>
                </a>

                <!--
                <p>{{ $t('contact.address.address') }}
                </p>
                <h5>{{ $t('contact.address.phone') }}:</h5>
                <p>
                  <a href="tel:0941971410"><PhoneIcon /> 094.197.1410 (Thai)</a>
                  <br /><a href="tel:0895149351"> <PhoneIcon /> 089.514.9351 (English) </a>
                </p> -->
              </div>
              <div class="right-side-contact">
                <ContactForm
                  :buttonId="'contact-button-clicked'"
                  :successMessageId="'success-message-sent'"
                />
              </div>
            </div>
          </b-tab>
        </b-tabs>
        <b-row no-gutters v-else>
          <b-col cols="12" class="mb-faq">
            <div class="choose-tab">
              <div class="custom-input" @click="showSidebar">
                <span class="text">{{ textTitle }}</span>
                <ChevronDownIcon />
              </div>
            </div>
            <div class="title">{{ textTitle }}</div>
            <div
              class="wrap-collapse"
              v-bind:class="{
                hide: isShowTab != 'frequently-questions',
                show: isShowTab == 'frequently-questions',
              }"
            >
              <b-card no-body class="mb-1">
                <b-button v-b-toggle.accordion-1>
                  <span>{{ $t("faq.accounts.name") }}</span>
                  <span class="when-opened">
                    <ChevronUpIcon />
                  </span>
                  <span class="when-closed">
                    <ChevronDownIcon />
                  </span>
                </b-button>

                <b-collapse
                  id="accordion-1"
                  accordion="my-accordion"
                  role="tabpanel"
                  :visible="$route.hash.match('-1') ? false : true"
                >
                  <!-- <b-card-body></b-card-body> -->
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-1-inner>
                      <span>Q. {{ $t("faq.accounts.question.1") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-1-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body
                        >A. {{ $t("faq.accounts.answer.1") }}</b-card-body
                      >
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-2-inner>
                      <span>Q. {{ $t("faq.accounts.question.2") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-2-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.accounts.answer.2") }}
                        <ol>
                          <li>
                            {{ $t("faq.accounts.answer.2a") }}
                            <b>{{ $t("faq.accounts.answer.2b") }}</b>
                            {{ $t("faq.accounts.answer.2c") }}
                          </li>
                          <li>{{ $t("faq.accounts.answer.2d") }}</li>
                          <li>{{ $t("faq.accounts.answer.2e") }}</li>
                        </ol>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-3-inner>
                      <span>Q. {{ $t("faq.accounts.question.3") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-3-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.accounts.answer.3") }}
                        <b>{{ $t("faq.accounts.answer.3a") }}</b>
                        {{ $t("faq.accounts.answer.3b") }}
                        <b>{{ $t("faq.accounts.answer.3c") }}</b>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </b-collapse>
              </b-card>
              <b-card no-body class="mb-1">
                <b-button v-b-toggle.accordion-2>
                  <span>{{ $t("faq.searching.name") }}</span>
                  <span class="when-opened">
                    <ChevronUpIcon />
                  </span>
                  <span class="when-closed">
                    <ChevronDownIcon />
                  </span>
                </b-button>

                <b-collapse
                  id="accordion-2"
                  accordion="my-accordion"
                  role="tabpanel"
                  :visible="$route.hash.match('-2') ? false : true"
                >
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-4-inner>
                      <span>Q. {{ $t("faq.searching.question.1") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-4-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A.
                        {{ $t("faq.searching.answer.1") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-5-inner>
                      <span>Q. {{ $t("faq.searching.question.2") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-5-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A.
                        <b>{{ $t("faq.searching.answer.2") }}</b>
                        {{ $t("faq.searching.answer.2a") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-6-inner>
                      <span>Q. {{ $t("faq.searching.question.3") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-6-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.searching.answer.3") }}
                        <b>{{ $t("faq.searching.answer.3a") }}</b>
                        {{ $t("faq.searching.answer.3b") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-7-inner>
                      <span>Q. {{ $t("faq.searching.question.4") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-7-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.searching.answer.4") }}
                        <b>{{ $t("faq.searching.answer.4a") }}</b>
                        {{ $t("faq.searching.answer.4b") }}
                        <b>{{ $t("faq.searching.answer.4c") }}</b>
                        {{ $t("faq.searching.answer.4d") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-8-inner>
                      <span>Q. {{ $t("faq.searching.question.5") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-8-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.searching.answer.5") }}
                        <b>{{ $t("faq.searching.answer.5a") }}</b>
                        {{ $t("faq.searching.answer.5b") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </b-collapse>
              </b-card>
              <b-card no-body class="mb-1">
                <b-button v-b-toggle.accordion-3>
                  <span>{{ $t("faq.posting.name") }}</span>
                  <span class="when-opened">
                    <ChevronUpIcon />
                  </span>
                  <span class="when-closed">
                    <ChevronDownIcon />
                  </span>
                </b-button>

                <b-collapse
                  id="accordion-3"
                  v-model="showCollapse"
                  accordion="my-accordion"
                  role="tabpanel"
                  :visible="$route.hash.match('-3') ? false : true"
                >
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-9-inner>
                      <span>Q. {{ $t("faq.posting.question.1") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-9-inner"
                      :visible="$route.hash.match('-9') ? true : false"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.posting.answer.1") }}
                        <br />
                        <ol>
                          <li>
                            {{ $t("faq.posting.answer.1a") }}
                            <b>{{ $t("faq.posting.answer.1b") }}</b>
                            {{ $t("faq.posting.answer.1c") }}
                          </li>
                          <li>
                            {{ $t("faq.posting.answer.1d") }}
                            <b>{{ $t("faq.posting.answer.1e") }}</b>
                            {{ $t("faq.posting.answer.1f") }}
                          </li>
                          <li>
                            {{ $t("faq.posting.answer.1g") }}
                            <b>{{ $t("faq.posting.answer.1h") }}</b>
                          </li>
                          <li>
                            {{ $t("faq.posting.answer.1i") }}
                            <b>{{ $t("faq.posting.answer.1j") }}</b>
                          </li>
                          <li>
                            {{ $t("faq.posting.answer.1k") }}
                            <b>{{ $t("faq.posting.answer.1l") }}</b>
                            {{ $t("faq.posting.answer.1m") }}
                            <b>{{ $t("faq.posting.answer.1n") }}</b>
                            {{ $t("faq.posting.answer.1o") }}
                          </li>
                          <li>
                            {{ $t("faq.posting.answer.1p") }}
                            <b>{{ $t("faq.posting.answer.1q") }}</b>
                            {{ $t("faq.posting.answer.1r") }}
                          </li>
                          <li>
                            <b>{{ $t("faq.posting.answer.1s") }}</b>
                            {{ $t("faq.posting.answer.1t") }}
                          </li>
                          <li>
                            {{ $t("faq.posting.answer.1u") }}
                            <b>{{ $t("faq.posting.answer.1v") }}</b>
                          </li>
                          <li>
                            {{ $t("faq.posting.answer.1w") }}
                            <b>{{ $t("faq.posting.answer.1x") }}</b>
                            {{ $t("faq.posting.answer.1y") }}
                          </li>
                          <li>
                            {{ $t("faq.posting.answer.1z") }}
                            <b>{{ $t("faq.posting.answer.1aa") }}</b>
                          </li>
                          <li>
                            {{ $t("faq.posting.answer.1ab") }}
                            <b>{{ $t("faq.posting.answer.1ac") }}</b>
                            {{ $t("faq.posting.answer.1ad") }}
                          </li>
                        </ol>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1" id="toggle-10">
                    <b-button v-b-toggle.accordion-10-inner>
                      <span>Q. {{ $t("faq.posting.question.2") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-10-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.posting.answer.2") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-11-inner>
                      <span>Q. {{ $t("faq.posting.question.3") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-11-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.posting.answer.3") }} <br />•
                        {{ $t("faq.posting.answer.3a") }} <br />•
                        {{ $t("faq.posting.answer.3b") }} <br />•
                        {{ $t("faq.posting.answer.3c") }} <br />•
                        {{ $t("faq.posting.answer.3d") }} <br />•
                        {{ $t("faq.posting.answer.3e") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-12-inner>
                      <span>Q. {{ $t("faq.posting.question.4") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-12-inner"
                      :visible="faq || $route.hash.match('-20')"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.posting.answer.4") }}
                        <router-link
                          id="seukhaiPromoteYourAd"
                          style="color: #444444"
                          :to="$i18nRoute({ name: 'ads' })"
                          >https://marketplace.khaosod.co.th/ads/promote-your-ad/</router-link
                        >{{ $t("faq.posting.answer.4a") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-13-inner>
                      <span>Q. {{ $t("faq.posting.question.5") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-13-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.posting.answer.5") }}
                        <br />
                        <b>{{ $t("faq.posting.answer.5a") }}</b>
                        {{ $t("faq.posting.answer.5b") }}
                        <br />
                        <b>{{ $t("faq.posting.answer.5c") }}</b>
                        {{ $t("faq.posting.answer.5d") }}
                        <br />
                        <b>{{ $t("faq.posting.answer.5e") }}</b>
                        {{ $t("faq.posting.answer.5f") }}
                        <br />
                        <b>{{ $t("faq.posting.answer.5g") }}</b>
                        {{ $t("faq.posting.answer.5h") }}
                        <br />
                        <b>{{ $t("faq.posting.answer.5i") }}</b>
                        {{ $t("faq.posting.answer.5j") }}
                        <br />
                        <b>{{ $t("faq.posting.answer.5k") }}</b>
                        {{ $t("faq.posting.answer.5l") }}
                        <br />
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-14-inner>
                      <span>Q. {{ $t("faq.posting.question.6") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-14-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.posting.answer.6") }}
                        <b>{{ $t("faq.posting.answer.6a") }}</b>
                        {{ $t("faq.posting.answer.6b") }}
                        <b>{{ $t("faq.posting.answer.6c") }}</b>
                        {{ $t("faq.posting.answer.6d") }}
                        <b>{{ $t("faq.posting.answer.6e") }}</b>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-15-inner>
                      <span>Q. {{ $t("faq.posting.question.7") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-15-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.posting.answer.7") }}
                        <b>{{ $t("faq.posting.answer.7a") }}</b>
                        {{ $t("faq.posting.answer.7b") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-16-inner>
                      <span>Q. {{ $t("faq.posting.question.8") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-16-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.posting.answer.8") }}
                        <b>{{ $t("faq.posting.answer.8a") }}</b>
                        {{ $t("faq.posting.answer.8b") }}
                        <b>{{ $t("faq.posting.answer.8c") }}</b>
                        {{ $t("faq.posting.answer.8d") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-17-inner>
                      <span>Q. {{ $t("faq.posting.question.9") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-17-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.posting.answer.9") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-18-inner>
                      <span>Q. {{ $t("faq.posting.question.10") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-18-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.posting.answer.10") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-19-inner>
                      <span>Q. {{ $t("faq.posting.question.11") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-19-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body
                        >A. {{ $t("faq.posting.answer.11") }}</b-card-body
                      >
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-20-inner>
                      <span>Q. {{ $t("faq.posting.question.12") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-20-inner"
                      :visible="$route.hash.match('-20') ? true : false"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.posting.answer.12") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-21-inner>
                      <span>Q. {{ $t("faq.posting.question.13") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-21-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.posting.answer.13") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-22-inner>
                      <span>Q. {{ $t("faq.posting.question.14") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-22-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.posting.answer.14") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-23-inner>
                      <span>Q. {{ $t("faq.posting.question.15") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-23-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.posting.answer.15") }}
                        <b>{{ $t("faq.posting.answer.15a") }}</b>
                        {{ $t("faq.posting.answer.15b") }}
                        <b>{{ $t("faq.posting.answer.15c") }}</b>
                        {{ $t("faq.posting.answer.15d") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-24-inner>
                      <span>Q. {{ $t("faq.posting.question.16") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-24-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body
                        >A. {{ $t("faq.posting.answer.16") }}</b-card-body
                      >
                    </b-collapse>
                  </b-card>
                </b-collapse>
              </b-card>
              <b-card no-body class="mb-1">
                <b-button v-b-toggle.accordion-4>
                  <span>{{ $t("faq.other.name") }}</span>
                  <span class="when-opened">
                    <ChevronUpIcon />
                  </span>
                  <span class="when-closed">
                    <ChevronDownIcon />
                  </span>
                </b-button>

                <b-collapse
                  id="accordion-4"
                  accordion="my-accordion"
                  role="tabpanel"
                  :visible="$route.hash.match('-4') ? false : true"
                >
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-25-inner>
                      <span>Q. {{ $t("faq.other.question.1") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-25-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.other.answer.1") }}
                        <b>{{ $t("faq.other.answer.1a") }}</b
                        >{{ $t("faq.other.answer.1b") }}
                        <b>{{ $t("faq.other.answer.1c") }}</b>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-button v-b-toggle.accordion-26-inner>
                      <span>Q. {{ $t("faq.other.question.2") }}</span>
                      <span class="when-opened">
                        <ChevronUpIcon />
                      </span>
                      <span class="when-closed">
                        <ChevronDownIcon />
                      </span>
                    </b-button>

                    <b-collapse
                      id="accordion-26-inner"
                      accordion="my-accordion-inner"
                      role="tabpanel"
                    >
                      <b-card-body>
                        A. {{ $t("faq.other.answer.2") }}
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </b-collapse>
              </b-card>
            </div>
            <div
              v-bind:class="{
                hide: isShowTab != 'terms-of-use',
                show: isShowTab == 'terms-of-use',
              }"
            >
              <div class="top-side">
                <a
                  @click="
                    changePrivacyPolicy(
                      false,
                      'TS',
                      'Terms_of_Service_Khaosod_FINAL'
                    )
                  "
                  v-bind:class="{ activeLang: !langTypeTS }"
                  >{{ $t("faq.thai") }} <span v-if="!langTypeTS">></span></a
                >
                <a
                  @click="changePrivacyPolicy(true, 'TS', 'Terms of Service')"
                  v-bind:class="{ activeLang: langTypeTS }"
                  >{{ $t("faq.english") }} <span v-if="langTypeTS">></span></a
                >
              </div>
              <pdf
                v-for="i in numPagesTS"
                :key="i"
                :page="i"
                :src="srcTS"
                style="display: inline-block; width: 100%"
              ></pdf>
            </div>
            <div
              v-bind:class="{
                hide: isShowTab != 'listing-policy',
                show: isShowTab == 'listing-policy',
              }"
            >
              <div class="top-side">
                <a
                  @click="
                    changePrivacyPolicy(
                      false,
                      'LP',
                      'Listing_Policy_Khaosod_FINAL'
                    )
                  "
                  v-bind:class="{ activeLang: !langTypeLP }"
                  >{{ $t("faq.thai") }} <span v-if="!langTypeLP">></span></a
                >
                <a
                  @click="changePrivacyPolicy(true, 'LP', 'Listing Policy')"
                  v-bind:class="{ activeLang: langTypeLP }"
                  >{{ $t("faq.english") }} <span v-if="langTypeLP">></span></a
                >
              </div>
              <pdf
                v-for="i in numPagesLP"
                :key="i"
                :page="i"
                :src="srcLP"
                style="display: inline-block; width: 100%"
              ></pdf>
            </div>
            <div
              v-bind:class="{
                hide: isShowTab != 'privacy-policy',
                show: isShowTab == 'privacy-policy',
              }"
            >
              <div class="top-side">
                <a
                  @click="
                    changePrivacyPolicy(
                      false,
                      'PP',
                      'Privacy_Policy_Khaosod_FINAL'
                    )
                  "
                  v-bind:class="{ activeLang: !langTypePP }"
                  >{{ $t("faq.thai") }} <span v-if="!langTypePP">></span></a
                >
                <!-- <a @click="changePrivacyPolicy(true, 'PP', 'Privacy Policy')" v-bind:class="{'activeLang': langTypePP}" >{{ $t('faq.english') }} <span v-if="langTypePP">></span></a>               -->
              </div>
              <pdf
                v-for="i in numPagesPP"
                :key="i"
                :page="i"
                :src="srcPP"
                style="display: inline-block; width: 100%"
              ></pdf>
            </div>
            <div
              v-bind:class="{
                hide: isShowTab != 'do-not-sell',
                show: isShowTab == 'do-not-sell',
              }"
            >
              <!-- <div class="top-side">
                <a
                  @click="changePrivacyPolicy(false, 'PP', 'Privacy_Policy_TH')"
                  v-bind:class="{ activeLang: !langTypePP }"
                  >{{ $t("faq.thai") }} <span v-if="!langTypePP">></span></a
                >
                <a
                  @click="changePrivacyPolicy(true, 'PP', 'Privacy Policy')"
                  v-bind:class="{ activeLang: langTypePP }"
                  >{{ $t("faq.english") }} <span v-if="langTypePP">></span></a
                >
              </div> -->
              <pdf
                v-for="i in numPagesDN"
                :key="i"
                :page="i"
                :src="srcDN"
                style="display: inline-block; width: 100%"
              ></pdf>
            </div>
            <div
              v-bind:class="{
                hide: isShowTab != 'contact-us',
                show: isShowTab == 'contact-us',
              }"
            >
              <div class="tab-list">
                <div class="left-side-contact" v-if="false">
                  <h5>{{ $t("contact.address.title") }}:</h5>

                  <p>{{ $t("contact.address.address") }}</p>
                  <h5>{{ $t("contact.address.phone") }}:</h5>
                  <p>
                    <a href="tel:0941971410"
                      ><PhoneIcon /> 094.197.1410 (Thai)</a
                    >
                    <br /><a href="tel:0895149351">
                      <PhoneIcon /> 089.514.9351 (English)
                    </a>
                  </p>
                </div>
                <div class="right-side-contact">
                  <ContactForm
                    :buttonId="'contact-button-clicked'"
                    :successMessageId="'success-message-sent'"
                  />
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="custom-sidebar">
      <div class="body-sidebar" v-bind:class="{ show: isShow }">
        <div @click="showTab('frequently-questions')">{{ $t("faq.faq") }}</div>
        <div @click="showTab('terms-of-use')">
          {{ $t("faq.termscondition") }}
        </div>
        <div @click="showTab('privacy-policy')">
          {{ $t("faq.privacyPolicy") }}
        </div>
        <div @click="showTab('listing-policy')">
          {{ $t("home.listingPolicy") }}
        </div>
        <div @click="showTab('do-not-sell')">
          {{ $t("Personal Information") }}
        </div>
        <div @click="showTab('contact-us')">{{ $t("faq.contactUs") }}</div>
      </div>
      <div
        class="overlay"
        v-bind:class="{ show: isShow }"
        @click="hideSidebar"
      ></div>
    </div>
    <Footer :adsFooter="adsFooter" />
  </div>
</template>
<script>
import Header from "@/components/ui/header";
import TitlePage from "@/components/ui/titlePage";
import Footer from "@/components/ui/footer";
import ContactForm from "../../components/contactForm/index";
import ChevronDownIcon from "vue-material-design-icons/ChevronDown.vue";
import ChevronUpIcon from "vue-material-design-icons/ChevronUp.vue";
import PhoneIcon from "vue-material-design-icons/Phone.vue";
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
window.PDFJS = window["pdfjs-dist/build/pdf"];
import pdf from "vue-pdf";
// var TS = pdf.createLoadingTask("../../pdf/Terms of Service.pdf");
// var PP = pdf.createLoadingTask("../../pdf/Privacy Policy.pdf");
// var LP = pdf.createLoadingTask("../../pdf/Listing Policy.pdf");

export default {
  name: "FaqScreen",
  components: {
    Header,
    TitlePage,
    Footer,
    ChevronDownIcon,
    ChevronUpIcon,
    pdf,
    ContactForm,
    PhoneIcon,
  },
  data() {
    return {
      srcTS: "",
      srcPP: "",
      srcLP: "",
      srcDN: "",
      numPagesDN: undefined,
      numPagesTS: undefined,
      numPagesPP: undefined,
      numPagesLP: undefined,
      isShow: false,
      isShowTab: "",
      textTitle: "",
      showAnswerNumber: 1,
      tabIndex: 0,
      show: 1,
      parentFAQ: false,
      langTypeTS: false,
      langTypePP: false,
      langTypeLP: false,
      showCollapse: false,
      adsFooter: null,
    };
  },
  computed: {
    ...mapGetters("FavouriteController", ["faq"]),
    ...mapGetters("UserController", ["isTablet", "isMobile"]),
  },
  mounted() {
    this.srcTS = pdf.createLoadingTask(
      "../../pdf/Terms_of_Service_Khaosod_FINAL.pdf"
    );
    this.srcPP = pdf.createLoadingTask(
      "../../pdf/Privacy_Policy_Khaosod_FINAL.pdf"
    );
    this.srcLP = pdf.createLoadingTask(
      "../../pdf/Listing_Policy_Khaosod_FINAL.pdf"
    );
    this.srcDN = pdf.createLoadingTask(
      "../../pdf/Do Not Sell My Personal Information.pdf"
    );

    this.srcTS.promise.then(async (pdf) => {
      this.numPagesTS = await pdf.numPages;
    });
    this.srcPP.promise.then(async (pdf) => {
      this.numPagesPP = await pdf.numPages;
    });
    this.srcLP.promise.then(async (pdf) => {
      this.numPagesLP = await pdf.numPages;
    });
    this.srcDN.promise.then(async (pdf) => {
      this.numPagesDN = await pdf.numPages;
    });

    if (window.location.hash == "#contact-us") {
      this.showTab("contact-us");
    } else if (window.location.hash == "#listing-policy") {
      this.showTab("listing-policy");
    } else if (window.location.hash == "#terms-of-use") {
      this.showTab("terms-of-use");
    } else if (window.location.hash == "#privacy-policy") {
      this.showTab("privacy-policy");
    } else if (window.location.hash == "#do-not-sell") {
      this.showTab("do-not-sell");
    } else {
      this.showTab("frequently-questions");
    }
  },
  created() {
    let locationId = 9;
    if (this.isMobile) {
      locationId = 49;
    }
    this.getFooterAds(locationId);
    if (this.faq) {
      this.showCollapse = true;
      setTimeout(function () {
        document
          .getElementById("toggle-10")
          .scrollIntoView({ behavior: "smooth" });
      }, 700);
    }
  },
  methods: {
    ...mapActions("AdsController", [
      "GETADS_FOR_PUBLIC_WEBSITE",
      "CLICK_BANNERADS",
    ]),
    changePrivacyPolicy(lang, type, fileName) {
      this[`langType${type}`] = lang;
      this[`src${type}`] = null;

      this[`src${type}`] = pdf.createLoadingTask(`../../pdf/${fileName}.pdf`);

      if (this[`src${type}`]) {
        this[`src${type}`].promise.then(async (pdf) => {
          this.numPagesTS = await pdf.numPages;
        });
      }
    },

    showSidebar() {
      this.isShow = true;
    },
    hideSidebar() {
      this.isShow = false;
    },
    showTab(name) {
      this.isShowTab = name;
      switch (name) {
        case "frequently-questions":
          this.textTitle = this.$t("faq.faq");
          break;
        case "terms-of-use":
          this.textTitle = this.$t("faq.termscondition");
          break;
        case "listing-policy":
          this.textTitle = this.$t("faq.anncouncemnetpolicy");
          break;
        case "contact-us":
          this.textTitle = this.$t("faq.contactUs");
          break;
        case "privacy-policy":
          this.textTitle = this.$t("faq.privacypolicy");
          break;
        case "do-not-sell":
          this.textTitle = this.$t("Do Not Sell My Personal Information");
          break;
        default:
          this.textTitle = this.$t("faq.faq");
          break;
      }
      this.hideSidebar();
    },
    activeTab(tabName) {
      switch (tabName) {
        case "frequentlyAskedQuestions":
          if (window.location.hash != "#frequently-asked-questions") {
            this.$router.push(
              `${this.$i18nRoute({ name: "faq" })}#frequently-asked-questions`
            );
          }
          break;
        case "termsOfUse":
          if (window.location.hash != "#terms-of-use")
            this.$router.push(
              `${this.$i18nRoute({ name: "faq" })}#terms-of-use`
            );
          break;
        case "privacyPolicy":
          if (window.location.hash != "#privacy-policy")
            this.$router.push(
              `${this.$i18nRoute({ name: "faq" })}#privacy-policy`
            );
          break;
        case "listingPolicy":
          if (window.location.hash != "#listing-policy")
            this.$router.push(
              `${this.$i18nRoute({ name: "faq" })}#listing-policy`
            );
          break;
        case "doNotSell":
          if (window.location.hash != "#do-not-sell")
            this.$router.push(
              `${this.$i18nRoute({ name: "faq" })}#do-not-sell`
            );
          break;
        case "contactUs":
          if (window.location.hash != "#contact-us")
            this.$router.push(`${this.$i18nRoute({ name: "faq" })}#contact-us`);
          break;
        default:
          break;
      }
    },
    getFooterAds(locationId) {
      console.log("locationId", locationId);
      this.GETADS_FOR_PUBLIC_WEBSITE({
        id: locationId,
      }).then(({ data }) => {
        console.log("data", data);
        if (data) {
          this.adsFooter = data;
          this.$forceUpdate();
        }
      });
    },
  },
  destroyed() {
    console.log("destroyed search");
    this.adsFooter = null;
  },
};
</script>
<style lang="scss">
@import "style.scss";
</style>